import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="8"
          viewBox="0 0 8 8"
        >
          <path d="M6.94 3.038l-.037-.013-.149-.355.016-.037c.45-1.02.42-1.051.345-1.125l-.6-.586A.16.16 0 006.408.88c-.034 0-.136 0-1.023.402l-.035.016-.366-.147-.015-.037C4.553.081 4.51.081 4.406.081h-.848c-.103 0-.15 0-.537 1.035l-.015.038-.364.148-.035-.014c-.6-.253-.95-.382-1.042-.382a.161.161 0 00-.105.041l-.601.588c-.076.075-.108.106.366 1.106l.017.037-.149.355-.036.014C0 3.455 0 3.495 0 3.6v.832c0 .106 0 .15 1.06.53l.037.014.149.353-.016.036C.78 6.388.808 6.416.885 6.491l.6.587a.165.165 0 00.105.042c.034 0 .136 0 1.024-.402l.035-.017.366.149.014.036c.418 1.033.46 1.033.565 1.033h.848c.107 0 .15 0 .538-1.036l.014-.037.365-.148.035.014c.6.254.95.382 1.04.382.037 0 .081-.016.106-.04l.602-.59c.076-.075.108-.106-.367-1.105l-.018-.037.149-.353.035-.014C8 4.545 8 4.505 8 4.398v-.831c0-.107 0-.15-1.06-.529zM4 5.348c-.758 0-1.375-.605-1.375-1.348 0-.743.617-1.347 1.375-1.347S5.374 3.257 5.374 4 4.758 5.348 4 5.348z"></path>
        </svg>
    );
}